module.exports = __webpack_public_path__ + "img/service1.4cc1b32d.png";